const localizedNetworkErrors = [
    /^TypeError: The network connection was lost/,
    /^TypeError: De netwerkverbinding is verbroken/,
    /^TypeError: Die Netzwerkverbindung wurde unterbrochen/,
    /^TypeError: La connexion réseau a été perdue/,
    /^TypeError: La connessione è stata persa/,
    /^TypeError: la connessione è stata persa/,
    /^TypeError: La conexión de red se ha perdido/,
    /^TypeError: החיבור לרשת אבד/,
    /^TypeError: A conexão de rede foi perdida/,
    /^TypeError: A ligação de rede foi cortada/,
    /^TypeError: Ağ bağlantısı kesildi/,
    /^TypeError: Mistet nettverksforbindelsen/,
    /^TypeError: Netværksforbindelsen gik tabt/,
    /^TypeError: Зʼєднання з мережею втрачено/,
    /^TypeError: A ligação à rede foi interrompida/,
    /^TypeError: ネットワーク接続が切れました/,
    /^TypeError: Η σύνδεση δικτύου χάθηκε/,
    /^TypeError: 网络连接已中断/,
    /^TypeError: 網絡連線中斷/,
    /^TypeError: 네트워크 연결이 유실되었습니다/,
    /^TypeError: تم فقدان اتصال الشبكة/,
    /^TypeError: 網路連線中斷。/,
    /^TypeError: Bylo ztraceno připojení k síti/,
    /^TypeError: Pripojenie k sieti bolo stratené/,
    /^TypeError: La conexión de red se perdió/,
    /^TypeError: La connexió de xarxa s’ha perdut/,
    /^TypeError: Nätverksanslutningen förlorades/,
    /^TypeError: Połączenie sieciowe zostało utracone/,
    /^TypeError: Verkkoyhteys katkesi/,
    /^TypeError: annullato/,
    /^TypeError: Unhandled Promise Rejection: TypeError: annullato/,
    /^TypeError: anulat/,
    // Error is used in Safari 14 when fetch request gets cancelled in the browser. https://request-cancellation-test.vercel.app
    /^TypeError: cancelled/,
    /^TypeError: cancelado/,
    /^TypeError: ถูกยกเลิก/,
    /^TypeError: visszavonva/,
    /^TypeError: annulé/,
    /^TypeError: zrušeno/,
    /^TypeError: annulleret/,
    /^TypeError: zrušené/,
    /^TypeError: geannuleerd/,
    /^TypeError: anulowane/,
    /^TypeError: Abgebrochen/,
    /^TypeError: Kumottu/,
    /^TypeError: בוטל/,
    /^TypeError: 已取消/,
    /^TypeError: キャンセルしました/,
    /^TypeError: مُلغى/,
    /^TypeError: отменено/,
    /^TypeError: avbruten/,
    /^TypeError: avbrutt/,
    /^TypeError: Kumottu/,
    /^TypeError: 취소됨/,
    // Error is used in Chrome when fetch request gets cancelled in the browser. https://request-cancellation-test.vercel.app
    /^TypeError: Failed to fetch/,
    /^TypeError: Unhandled Promise Rejection: Failed to fetch/,
    // Error is used in Safari 15 when fetch request gets cancelled in the browser. https://request-cancellation-test.vercel.app
    /^TypeError: Load failed$/,
    /^TypeError: TypeError: Load failed$/,
    /^NetworkError: Load failed$/,
    /^TypeError: Unhandled Promise Rejection: Load failed$/,
    /^TypeError: Unhandled Promise Rejection: TypeError: Load failed$/,
    /^TypeError: Сетевое соединение потеряно/,
    /^TypeError: ακυρώθηκε/,
    /^TypeError: WebKit a rencontré une erreur interne/,
    /^TypeError: WebKit encountered an internal error/,
    /^TypeError: Er heeft zich in WebKit een interne fout voorgedaan/,
    /^TypeError: WebKit hat einen internen Fehler festgestellt/,
    /^TypeError: WebKit påträffade ett internt fel/,
    /^Error: Määrittämätön virhe/,
    /^Error: Niet nader omschreven fout/,
    /^Module fetching failed: ChunkLoadError: Loading chunk [0-9]+ failed\./,
    /^ChunkLoadError: Loading chunk [0-9]+ failed\./,
    /^ChunkLoadError: Unhandled Promise Rejection: Loading chunk [0-9]+ failed\./,
    /^Module fetching failed \(WebDriver detected\):/,
];

// These are caused mostly by google translate extension trying to modify react nodes, mainly fragments
const reactNodeReplacementErrors = [
    /^NotFoundError: Failed to execute 'removeChild' on 'Node'/,
    /^NotFoundError: Failed to execute 'insertBefore' on 'Node'/,
];

const expectedErrors = [
    /^BadRequestError: The interval must not exceed 370D\./,
    /^ReferenceError: Can't find variable: __firefox__/,
    /^ReferenceError: Can't find variable: __init14/,
    /^ReferenceError: Can't find variable: __initialized/,
    /^ReferenceError: Can't find variable: __scanAndKill/,
    /^ReferenceError: Can't find variable: instantSearchSDKJSBridgeClearHighlight/,
    /^ReferenceError: Can't find variable: webkit/,
    /^ReferenceError: dbUpdated is not defined/,
    /^ReferenceError: tgetT is not defined/,
];

const networkErrors = [/NetworkError/, /AbortError/];

const resizeObserverLoopFilter = /^ResizeObserver loop/;

export const SENTRY_ERROR_FILTERS = [
    ...localizedNetworkErrors,
    ...expectedErrors,
    ...networkErrors,
    ...reactNodeReplacementErrors,
    resizeObserverLoopFilter,
];
export const SENTRY_WARNING_FILTERS: RegExp[] = [...localizedNetworkErrors, ...expectedErrors, ...networkErrors];
